import Service from '@/service/building'

const HOUSE = {
    key: 'house',
    name: '购房进度'
}
const TALENT = {
    key: 'talent',
    name: '人才购房进度'
}

export default {
    data() {
        return {
            select_house_progress_tab: 'house'
        }
    },
    computed: {
        is_talent_progress() {
            return this.select_house_progress_tab === 'talent'
        },
        house_progress_tabs() {
            const { talent_stages } = this.current_house
            return talent_stages && talent_stages.length ? [HOUSE, TALENT] : [HOUSE]
        }
    },
    watch: {
        house_progress_tabs(latest, old) {
            if (latest.length !== old.length) {
                this.select_house_progress_tab =  'house'
            }
        }
    },
    methods: {
        changeHouseProgressType (e) {
            this.select_house_progress_tab = e.detail.key
        },
        async goTalent(key) {
            if (!this.current_house[key] || this.current_house[key].includes('pending')) {
                return
            }
            const methods = {
                'trd_status': 'getTrdResults',
                'tsd_status': 'getTsdResults'
            }[key]
            const {result_type, result_url} = await Service[methods](this.current_house.id)
            if (result_type === 'url') {
                wx.navigateTo({
                    url: `/web_page?link=${encodeURIComponent(result_url)}&title=成都购房通`
                })
            }
        }
    }
}